import { render, staticRenderFns } from "./ModelTextareaComponent.vue?vue&type=template&id=77db9d1c&scoped=true&"
import script from "./ModelTextareaComponent.vue?vue&type=script&lang=js&"
export * from "./ModelTextareaComponent.vue?vue&type=script&lang=js&"
import style0 from "./ModelTextareaComponent.vue?vue&type=style&index=0&id=77db9d1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77db9d1c",
  null
  
)

export default component.exports